import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { formatCurrency } from '../../shared/utils/currency';
import { renderIcon } from '../../shared/utils/iconUtils'; // Import the shared icon utility

ChartJS.register(ArcElement, Tooltip, Legend);

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ffc658', '#d0ed57', '#a4de6c', '#8dd1e1'];

const PaymentSourcePieChart = ({ expenses, currency, paymentSources }) => {
  const filteredExpenses = expenses; // Expenses are already filtered by excludedCategories in App.js

  const paymentSourcesData = filteredExpenses.reduce((acc, expense) => {
    const source = expense.payment_source;
    const amount = Math.abs(expense.amount);
    if (!acc[source]) {
      acc[source] = { amount: 0, icon: '' };
    }
    acc[source].amount += amount;
    // Find the icon for the payment source
    const ps = paymentSources.find(p => p.source_name === source);
    if (ps) {
      acc[source].icon = ps.icon;
    }
    return acc;
  }, {});

  const labels = Object.keys(paymentSourcesData);
  const dataValues = Object.values(paymentSourcesData).map(item => item.amount);
  const icons = Object.values(paymentSourcesData).map(item => item.icon);

  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Expenses by Payment Source',
        data: dataValues,
        backgroundColor: COLORS.slice(0, labels.length), // Use COLORS array
        borderColor: COLORS.slice(0, labels.length),     // Use COLORS array
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Allow chart to fill container without maintaining aspect ratio
    plugins: {
      legend: {
        position: 'right', // Set legend position to right
        labels: {
          generateLabels: function(chart) {
            const data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function(label, i) {
                const meta = chart.getDatasetMeta(0);
                const style = meta.controller.getDataset().backgroundColor[i]; // Corrected access
                const iconName = icons[i]; // Get the icon name
                return {
                  text: label,
                  fillStyle: style,
                  strokeStyle: style,
                  lineWidth: 1,
                  hidden: chart.getDatasetMeta(0).data[i].hidden,
                  index: i,
                  icon: iconName // Pass icon name to legend item
                };
              });
            }
            return [];
          },
          // Custom filter to render icon
          filter: function(legendItem, chartData) {
            return (
              <div className="d-flex align-items-center">
                {legendItem.text}
              </div>
            );
          }
        }
      },
      tooltip: {
        callbacks: {
          title: function(tooltipItems) {
            const label = tooltipItems[0].label;
            return label;
          },
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed !== null) {
              label += formatCurrency(context.parsed, currency);
            }
            return label;
          }
        }
      }
    },
  };

  return (
    <div className="chart-container" style={{ height: '400px' }}> {/* Define a height for responsiveness */}
      <Pie data={data} options={options} />
    </div>
  );
};

export default PaymentSourcePieChart;
